<span
  class="profile-picture"
  *ngIf="user"
  [ngStyle]="{
    'background-image':
      'url(' +
      (user.profile_picture || 'image/default_profile_picture.png' | assets) +
      ')',
  }"
  [ngClass]="{
    'no-margin': 'noMargin',
    small: size === 'small',
    medium: size === 'medium',
  }"></span>
